import type { ReactNode } from 'react';
import { forwardRef } from 'react';

import type { TransactionAnalysisData } from '../hooks/useTransactionAnalysisReportSections';
import { BaseReport } from '../../reports/BaseReport';
import { useTransactionAnalysisReportSections } from '../hooks/useTransactionAnalysisReportSections';

type TransactionAnalysisReportProps = TransactionAnalysisData & {
  disableSectionObserver?: boolean;
  header?: ReactNode;
};

export const TransactionAnalysisReport = forwardRef<HTMLDivElement, TransactionAnalysisReportProps>(
  ({ disableSectionObserver = false, header, ...data }, ref) => {
    const { sections } = useTransactionAnalysisReportSections(data);

    if (sections.length === 0) {
      return null;
    }

    return (
      <BaseReport
        ref={ref}
        sections={sections}
        disableSectionObserver={disableSectionObserver}
        header={header}
      />
    );
  },
);

TransactionAnalysisReport.displayName = 'TransactionAnalysisReport';
